import { useMutation } from "@tanstack/react-query";
import { fetchSampleSummaryPreviewHtml } from "../api/rfx-report-api";
import type { RfxSummaryPreviewParams, RfxReportPreviewHtmlResponse } from "../types";

export const useSampleSummaryPreviewHtml = () => {
	return useMutation<RfxReportPreviewHtmlResponse, Error, RfxSummaryPreviewParams>({
		mutationFn: (params) => fetchSampleSummaryPreviewHtml(params),
	});
};
